module.exports=function(r){var n=String(r).split("."),t=n[0],e=Number(n[0])==r;return 1!=r&&(e||0!=t&&1!=t)?"other":"one"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-format/locale/da/quantify.js
// module id = 603
// module chunks = 0